import { Filter } from "lucide-react";
import React from "react";

import Button from "../button/Button";

/**
 * Standard list-page control to open a filters drawer/modal.
 * Active filter count appears as a badge on the button corner.
 */
const FiltersButton = ({
  activeFilterCount = 0,
  onClick,
  countDataCy,
  ...rest
}) => {
  return (
    <div className="relative inline-flex shrink-0">
      <Button
        variant="secondary"
        size="sm"
        leftIcon={<Filter className="h-3 w-3" />}
        onClick={onClick}
        {...rest}
      >
        Filters
      </Button>
      {activeFilterCount > 0 && (
        <span
          className="absolute -right-1.5 -top-1.5 z-10 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-primary px-1.5 text-body font-semibold leading-none text-white"
          aria-label={`${activeFilterCount} active filter${activeFilterCount === 1 ? "" : "s"}`}
          data-cy={countDataCy}
        >
          {activeFilterCount}
        </span>
      )}
    </div>
  );
};

export default FiltersButton;
